/**
 * 官网语种清单 —— 与后端 dp_lang(status=1) 的 20 个启用语种一一对齐。
 * 顺序即语言下拉的展示顺序（中文优先，亚太次之，欧洲再次，小语种靠后）。
 * label 为界面显示名（各语言自称）；short 为下拉里的角标。
 */
export const SITE_LANGS = [
  { sign: 'zh-CN', label: '中文', short: 'ZH' },
  { sign: 'zh-TW', label: '繁體中文', short: 'ZH-TW' },
  { sign: 'en', label: 'English', short: 'EN' },
  { sign: 'ja', label: '日本語', short: 'JA' },
  { sign: 'ko', label: '한국어', short: 'KO' },
  { sign: 'ru', label: 'Русский', short: 'RU' },
  { sign: 'de', label: 'Deutsch', short: 'DE' },
  { sign: 'fr', label: 'Français', short: 'FR' },
  { sign: 'es', label: 'Español', short: 'ES' },
  { sign: 'pt', label: 'Português', short: 'PT' },
  { sign: 'it', label: 'Italiano', short: 'IT' },
  { sign: 'ar', label: 'العربية', short: 'AR', rtl: true },
  { sign: 'tr', label: 'Türkçe', short: 'TR' },
  { sign: 'vi', label: 'Tiếng Việt', short: 'VI' },
  { sign: 'th', label: 'ไทย', short: 'TH' },
  { sign: 'id', label: 'Bahasa Indonesia', short: 'ID' },
  { sign: 'ms', label: 'Melayu', short: 'MS' },
  { sign: 'kk', label: 'Қазақша', short: 'KK' },
  { sign: 'my', label: 'မြန်မာ', short: 'MY' },
  { sign: 'lo', label: 'ພາສາລາວ', short: 'LO' },
]

export function findLang (sign) {
  return SITE_LANGS.find(l => l.sign === sign) || SITE_LANGS[0]
}

export function isRtlLocale (sign) {
  return sign === 'ar'
}

/**
 * 决定首屏用哪个语种。router / store / main.js 都调它，保证三处算出来的结果一致
 * （早先 router 直接读 localStorage，首次访问时和 store 的判断会打架：
 * 标题是中文、正文却是英文）。
 *
 * 优先级：localStorage（用户主动切过，最高）→ navigator.languages 逐个匹配
 * （先精确匹配 zh-CN/zh-TW，再按主语言匹配 en-US→en、pt-BR→pt）
 * → zh 泛指按简体（zh-HK/zh-MO 按繁体习惯归 zh-TW）→ 兜底英文，
 * 因为跨境开店平台的海外访客远多于中文访客。
 *
 * 匹配结果会写回 localStorage：旧页面（注册、个人中心等）还留着
 * localStorage.getItem('langdef') || 'en' 这种老读法，不写回就会各说各话。
 */
export function detectLang () {
  let saved = ''
  try {
    saved = localStorage.getItem('langdef') || ''
  } catch (e) { /* 隐私模式下 localStorage 可能被禁 */ }
  if (saved && SITE_LANGS.some(l => l.sign === saved)) return saved

  let prefs = []
  try {
    prefs = (navigator.languages && navigator.languages.length)
      ? navigator.languages
      : [navigator.language || '']
  } catch (e) { /* 防御旧环境 */ }

  const picked = matchFromPrefs(prefs)
  try {
    localStorage.setItem('langdef', picked)
  } catch (e) { /* 写不进去也不影响本次渲染 */ }
  return picked
}

function matchFromPrefs (prefs) {
  for (let i = 0; i < prefs.length; i++) {
    const tag = String(prefs[i] || '').toLowerCase()
    if (!tag) continue
    const exact = SITE_LANGS.find(l => l.sign.toLowerCase() === tag)
    if (exact) return exact.sign
    const primary = tag.split('-')[0]
    if (primary === 'zh') {
      // zh-HK / zh-MO 是繁体习惯 → 繁体站；其余 zh 泛指 → 简体
      return (tag === 'zh-hk' || tag === 'zh-mo') ? 'zh-TW' : 'zh-CN'
    }
    const hit = SITE_LANGS.find(l => l.sign.toLowerCase() === primary)
    if (hit) return hit.sign
  }
  return 'en'
}
